// VersionInfo.js

import React from "react";
import { useTranslation } from "react-i18next";
import { FaInfoCircle } from "react-icons/fa";

const VersionInfo = () => {
  const { t } = useTranslation();
  const version = process.env.REACT_APP_VERSION;
  const notesRaw = process.env.REACT_APP_VERSION_TEXT;
  const notes = notesRaw ? String(notesRaw).replace(/\\n/g, "\n") : "";

  return (
    <div className="version-info">
      <div className="version-number wms-version-label">
        {t("version.label", { version: version ?? "" })}
      </div>
      <FaInfoCircle className="info-icon" />
      {notes ? (
        <div className="tooltip">
          {t("version.tooltip", { notes })}
        </div>
      ) : null}
    </div>
  );
};

export default VersionInfo;
